import * as React from 'react'
import classNames from 'classnames'

interface Props {
    inline?: boolean
    validationMessages: string[]
}

export function ElementValidation(props: Props) {
    if (props.validationMessages.length === 0) return null

    return (
        <div className="AppCore__flow__ExecutionElement__validation-messages">
            {props.validationMessages.map((validationMessage) => (
                <div
                    className={classNames('AppCore__flow__ExecutionElement__validation-message', {
                        inline: props.inline,
                    })}
                >
                    <zaptic-icon icon-name="alert" />
                    <div className="AppCore__flow__ExecutionElement__validation-message-text">{validationMessage}</div>
                </div>
            ))}
        </div>
    )
}
